import { TransitionGroup } from 'react-transition-group';
import { canValidateOpgavekompleksetTask, hasOpgavekompleksetTaskInputs } from '@utils/component-framework';
import { CSSRefTransition } from '@utils/react';
import { useGoToNextTaskAction } from '../../../state/actions/task.go-to-next.js';
import { useValidateCurrentTaskAction } from '../../../state/actions/task.validate-current.js';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { useCurrentTask } from '../../../state/hook.current-task.js';
import { useCurrentTaskEntryId, useCurrentTaskEntry } from '../../../state/hook.entry.js';
import { useAttemptMutation } from '../../../state/mutations/use-attempt.js';
import { makeSelectTaskState } from '../../../state/selectors/task.get-state.js';
import { shouldShowFeedback } from '../../../state/util.should-show-feedback.js';
import { crossfadeWrapper, crossfadeContainer, crossfadeDurationMs, actions } from './_actions.style.js';
import { NextButton } from './button.next.js';
import { SkipButton } from './button.skip.js';
import { ValidateButton } from './button.validate.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function FixedProgressionActions() {
  const component = useOpgavekompleksetComponent();
  const currentTask = useCurrentTask();
  const goToNextTask = useGoToNextTaskAction();
  const makeAttempt = useAttemptMutation();
  const validateCurrentTask = useValidateCurrentTaskAction();
  const currentTaskId = useCurrentTaskEntryId();
  const canValidate = canValidateOpgavekompleksetTask(currentTask.task);
  const hasInputs = hasOpgavekompleksetTaskInputs(currentTask.task);
  const canProgress = useCurrentTaskEntry({
    select: entry => Object.keys(entry?.details ?? {}).length > 0
  }) || !hasInputs;
  const taskState = useCurrentTaskEntry({
    select: makeSelectTaskState(component.data)
  }) ?? "facit";
  const isLastTask = component.data.tasks.findLastIndex(it => it.id === currentTaskId) === component.data.tasks.length - 1;
  const onNextButtonClick = () => {
    if (!shouldShowFeedback(component.data.settings.flowType)) {
      makeAttempt(currentTaskId);
      setTimeout(() => {
        goToNextTask();
      });
    } else {
      goToNextTask();
    }
  };
  const showNextButton = !canValidate || taskState !== "input" || !shouldShowFeedback(component.data.settings.flowType);
  return /*#__PURE__*/jsx(TransitionGroup, {
    className: crossfadeWrapper,
    children: /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: crossfadeDurationMs,
      classNames: crossfadeContainer,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: crossfadeContainer,
        children: /*#__PURE__*/jsxs("div", {
          className: actions,
          children: [taskState === "input" && hasInputs && /*#__PURE__*/jsx(SkipButton, {}), showNextButton ? /*#__PURE__*/jsx(NextButton, {
            theme: "primary",
            onClick: onNextButtonClick,
            disabled: !canProgress,
            label: isLastTask ? "Se resultat" : "Næste",
            tooltip: !canProgress ? {
              body: "Udfyld opgaven, for at gå videre",
              ariaType: "description",
              placement: "top"
            } : undefined
          }) : /*#__PURE__*/jsx(ValidateButton, {
            onClick: validateCurrentTask,
            currentTaskId: currentTaskId
          })]
        })
      })
    }, `${taskState === "input"}-${canValidate}-${hasInputs}-${isLastTask}`)
  });
}

export { FixedProgressionActions };
//# sourceMappingURL=integration.fixed-progression.js.map
